// extracted by mini-css-extract-plugin
module.exports = {"canvas":"TriangleRow_canvas__342AU"};